export const MY_TEAM_PATH = "/my-team";
